import { getDominantColor } from './imageUtils'

export async function generateBrandColorFromLogo(logoUrl: string): Promise<string> {
  try {
    const dominantColor = await getDominantColor(logoUrl)
    if (dominantColor) {
      return dominantColor
    }
  } catch (error) {
    console.error('Error generating brand color from logo:', error)
  }

  // Fallback to a default color if we can't extract from logo
  return '#5F0CE2' // Default brand color
}

export function isLightColor(color?: string): boolean {
  if (!color) return false

  // Handle HSL colors
  if (color.startsWith('hsl')) {
    const matches = color.match(/\d+/g)
    if (matches && matches.length >= 3) {
      const [h, s, l] = matches.map(Number)
      return l > 65
    }
  }
  // Handle hex and rgb colors
  let r, g, b

  if (color.startsWith('rgb')) {
    const matches = color.match(/\d+/g)
    if (matches && matches.length >= 3) {
      [r, g, b] = matches.map(Number)
    }
  } else {
    const hex = color.replace('#', '')
    r = parseInt(hex.substr(0, 2), 16)
    g = parseInt(hex.substr(2, 2), 16)
    b = parseInt(hex.substr(4, 2), 16)
  }

  const brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000
  return brightness > 155
}
